import Home from '../views/authentication/home';

var authRoutes = [
    { path: '/home', name: 'Home', icon: 'mdi mdi-account-key', component: Home }, //
];
export default authRoutes;